export default __webpack_public_path__ + "static/media/detail_mobile_16_4.3adee187.jpg";